import React, { useContext, useState } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import Notificationicon from "../../../assets/svg/notifications.svg";
import Notification from "../../../components/Notification";
import help from "../../../assets/svg/help.svg";
import SidebarContext from "../../../context/SidebarContext";
import DHL from "../../../assets/images/dhlimage.png";
import UPS from "../../../assets/images/upsimage.png";
import FEDEX from "../../../assets/images/fedeximage.png";
import TrackingIncluded from "../../../assets/images/Tracking_Included.png";
import Duties from "../../../assets/images/Duties.png";
import Insurance from "../../../assets/images/Insurance.png";
import CheckIcon from "@mui/icons-material/Check";
import ReviewYourShipment from "./ReviewYourShipment";

const shippingOptions = [
  {
    id: 1,
    logo: UPS,
    title: "USPS International Express",
    days: "3-5 Business Days",
    price: "$45.99",
    insurance: true,
    tracking: true,
    duties: "Pre-Paid",
  },
  {
    id: 2,
    logo: FEDEX,
    title: "FedEx International priority",
    days: "1-3 Business Days",
    price: "$72.99",
    insurance: true,
    tracking: true,
    duties: "Post-Paid",
  },
  {
    id: 3,
    logo: DHL,
    title: "DHL Express Worldwide",
    days: "2-4 Business Days",
    price: "$65.99",
    insurance: true,
    tracking: true,
    duties: "Pre-Paid",
  },
];

function ResultPage() {
  const { open } = useContext(SidebarContext);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [selectCardData, setSelectCardData] = useState(null);

  const breadcrumbs = [
    <Link
      key="1"
      to="/"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Home
    </Link>,
    <Link
      key="2"
      to="/shipping/route-partner"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Shipping Service
    </Link>,
    <Link
      key="3"
      to="/shipping/get-shipping-quote"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Get Shipping Quote
    </Link>,
    <Typography
      key="4"
      sx={{ color: "#959BA1", fontWeight: 500, fontSize: "12px" }}
    >
      Result
    </Typography>,
  ];

  const toggleNotification = () => {
    setNotificationDrawerOpen(!notificationDrawerOpen);
  };

  return (
    <>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: { xs: "auto", sm: "96vh" },
          minHeight: { xs: "100vh", sm: "96vh" },
          overflowY: "auto",
          margin: { xs: "10px", sm: "15px", md: "20px" },
          marginRight: { xs: "10px", sm: "15px", md: "0px" },
          width: {
            xs: "calc(100vw - 20px)",
            sm: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
          },
          backgroundColor: "#FFF",
          padding: { xs: "15px", sm: "20px" },
          border: "2px solid #E5E5E8",
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            borderBottom: "1px solid #E5E5E8",
            paddingBottom: "8px",
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
            <Typography
              sx={{
                fontSize: { xs: "20px", sm: "24px", md: "26px" },
                fontWeight: "bold",
              }}
            >
              Result
            </Typography>
            <Breadcrumbs
              separator="›"
              aria-label="breadcrumb"
              sx={{
                "& .MuiBreadcrumbs-ol": {
                  flexWrap: { xs: "wrap", sm: "nowrap" },
                },
              }}
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "flex-start", sm: "flex-end" },
              gap: { xs: 1, sm: 0 },
            }}
          >
            <Box
              sx={{
                marginRight: { xs: "10px", sm: "20px" },
                cursor: "pointer",
              }}
              onClick={toggleNotification}
            >
              <img src={Notificationicon} alt="notification_icon" />
            </Box>
            <Notification
              open={notificationDrawerOpen}
              onClose={toggleNotification}
            />
            <Box>
              <img src={help} alt="help_icon" />
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: "flex", mt: { xs: 2, sm: 4 } }}>
          <Grid container spacing={{ xs: 2, sm: 4 }}>
            {/* Left Section */}
            <Grid
              item
              xs={12}
              md={8}
              sx={{
                borderRight: { xs: "none", md: "2px solid #E5E5E8" },
                borderBottom: { xs: "2px solid #E5E5E8", md: "none" },
                paddingBottom: { xs: 2, md: 0 },
                marginBottom: { xs: 2, md: 0 },
                height: { xs: "auto", md: "100vh" },
                paddingRight: { xs: 0, md: "1rem" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    justifyContent: "space-between",
                    gap: { xs: 2, sm: 4 },
                    mb: { xs: 2, sm: 3 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                      gap: { xs: 2, sm: 4, md: "15rem" },
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Typography>
                      <strong
                        style={{
                          fontWeight: 500,
                          fontSize: "12px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                          color: "#959BA1",
                        }}
                      >
                        From Country
                      </strong>
                      <br />
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: "16px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                          color: "#1C2630",
                        }}
                      >
                        United States
                      </span>
                    </Typography>
                    <Typography>
                      <strong
                        style={{
                          fontWeight: 500,
                          fontSize: "12px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                          color: "#959BA1",
                        }}
                      >
                        Dimension
                      </strong>
                      <br />
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: "16px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                          color: "#1C2630",
                        }}
                      >
                        12×12×8
                      </span>
                    </Typography>
                    <Typography>
                      <strong
                        style={{
                          fontWeight: 500,
                          fontSize: "12px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                          color: "#959BA1",
                        }}
                      >
                        Weight
                      </strong>
                      <br />
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: "16px",
                          lineHeight: "120%",
                          letterSpacing: "0px",
                          color: "#1C2630",
                        }}
                      >
                        2.5kg
                      </span>
                    </Typography>
                  </Box>
                  <Button
                    variant="outlined"
                    size="small"
                    sx={{
                      ml: { xs: 0, sm: "auto" },
                      width: { xs: "100%", sm: "71px" },
                      mt: { xs: 2, sm: 0 },
                    }}
                  >
                    Edit
                  </Button>
                </Box>

                <Box>
                  {shippingOptions.map((option) => {
                    const isSelected = selectCardData?.id === option.id;
                    return (
                      <Card
                        key={option.id}
                        sx={{
                          mb: 2,
                          border: isSelected
                            ? "1px solid #38A34F"
                            : "1px solid #E5E5E8",
                          borderRadius: 2,
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectCardData(option)}
                      >
                        {isSelected && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              width: 0,
                              height: 0,
                              borderTop: "40px solid #38A34F",
                              borderLeft: "40px solid transparent",
                              zIndex: 1,
                            }}
                          >
                            <CheckIcon
                              sx={{
                                position: "absolute",
                                top: -34,
                                right: 5,
                                color: "white",
                                fontSize: "15px",
                              }}
                            />
                          </Box>
                        )}

                        <CardContent sx={{ padding: "0px" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                gap: 2,
                                mt: 3,
                                padding: "10px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: 2,
                                }}
                              >
                                <img
                                  src={option.logo}
                                  alt={option.title}
                                  width={48}
                                />
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "16px",
                                      lineHeight: "120%",
                                      letterSpacing: "0px",
                                      color: "#1C2630",
                                    }}
                                    variant="subtitle1"
                                    fontWeight={600}
                                  >
                                    {option.title}
                                  </Typography>
                                  <Typography
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "12px",
                                      lineHeight: "120%",
                                      letterSpacing: "0px",
                                      color: "#1C2630",
                                    }}
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {option.days}
                                  </Typography>
                                </Box>
                              </Box>
                              <Typography
                                variant="h6"
                                style={{
                                  fontWeight: 700,
                                  fontSize: "20px",
                                  lineHeight: "120%",
                                  letterSpacing: "0px",
                                  color: "#1C2630",
                                }}
                              >
                                {option.price}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                borderTop: "1px solid #E5E5E8",
                                padding: "10px",
                              }}
                            >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                gap: { xs: 1, sm: 2, md: 4 },
                                ml: { xs: 0, sm: 2 },
                                mt: 1,
                              }}
                            >
                                <Typography
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                  variant="caption"
                                >
                                  <img
                                    src={Insurance}
                                    alt={"Insurance"}
                                    width={20}
                                  />
                                  <spam
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      lineHeight: "120%",
                                      letterSpacing: "0px",
                                      color: "#000000",
                                    }}
                                  >
                                    Insurance
                                  </spam>
                                </Typography>
                                <Typography
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                  variant="caption"
                                >
                                  <img
                                    src={TrackingIncluded}
                                    alt={"Tracking_Included"}
                                    width={20}
                                  />
                                  <spam
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      lineHeight: "120%",
                                      letterSpacing: "0px",
                                      color: "#000000",
                                    }}
                                  >
                                    Tracking Included
                                  </spam>
                                </Typography>
                                <Typography
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                  variant="caption"
                                >
                                  <img src={Duties} alt={"Duties"} width={20} />
                                  <spam
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      lineHeight: "120%",
                                      letterSpacing: "0px",
                                      color: "#000000",
                                    }}
                                  >
                                    Duties: {option.duties}
                                  </spam>
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    );
                  })}
                </Box>
              </Box>
            </Grid>

            {/* Right Box */}
            <Grid item xs={12} md={4}>
              <ReviewYourShipment selectCardData={selectCardData} />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}

export default ResultPage;
